import { combineReducers } from 'redux'
import {
  NotificationActions,
  DomainActions,
  AppStateActions,
  LeaderboardActions,
  BadgeActions
} from './actions';

var initialNotifications = [];

function deleteSingleNotification(notifications, notificationId){
  return notifications.filter (function (notification) {
    return notification.id !== notificationId;
  });
}

const notifications = (state = initialNotifications, action) => {
  switch (action.type) {
    case NotificationActions.NEW_NOTIFICATION:
      // return new state array with keeping all notifications from previous state and adding our new one
      var notification = action.payload;
      var parsedNotification = {
        id: notification.id || "999",
        type: notification.type || "info",
        dismissible: notification.dismissible !== undefined? notification.dismissible : true,
        visible: notification.visible  !== undefined? notification.visible : true,
        header: notification.header || "",
        content: notification.content || "",
        buttonText: notification.buttonText || "",
        loading: notification.loading !== undefined? notification.loading : false,
        autoHide: notification.autoHide !== undefined? notification.autoHide : false
      };
      return Object.assign([], [ ...state, parsedNotification ]);

    case NotificationActions.CLEAR_SINGLE_NOTIFICATION:
      // return new state array with keeping all notifications from previous state and deleting the specified one
      return Object.assign([], deleteSingleNotification(state, action.payload));

    case NotificationActions.CLEAR_NOTIFICATIONS:
      // return new state object after clearing all notifications from the notifications array
      return []; // or return Object.assign([]);; ??

    default:
      return state;
  }
}


var initialDomains = [];

const domains = (state= initialDomains, action) => {
  switch(action.type){
    case DomainActions.SET_DOMAINS_LIST:
      return Object.assign([], action.payload);
    case DomainActions.CLEAR_DOMAINS_LIST:
      return [];
    default:
      return state;
  }
}

var initialLeaderboards = [];

const leaderboards = (state= initialLeaderboards, action) => {
  switch(action.type){
    case LeaderboardActions.SET_LEADERBOARD_LIST:
      return Object.assign([], action.payload);
    case LeaderboardActions.CLEAR_LEADERBOARD_LIST:
      return [];
    default:
      return state;
  }
}

var initialBadges = []

const badgelist = (state= initialBadges, action) => {
  switch(action.type){
    case BadgeActions.SET_BADGES:
      return Object.assign([], action.payload)
    default:
      return state
  }
}


var initialAppStae = {
  isLoading: false,
  user: 'nobody',
  serverClientTimeOffset: 0
};

const appState = (state= initialAppStae, action) => {
  switch(action.type){
    case AppStateActions.SET_LOADING_TRUE:
      return Object.assign({}, state, { isLoading: true });
    case AppStateActions.SET_LOADING_FALSE:
      return Object.assign({}, state, { isLoading: false });
    case AppStateActions.SET_LOGGED_IN_USER:
      return Object.assign({}, state, { user: action.payload })
    case AppStateActions.SET_SERVER_CLIENT_TIMEOFFSET:
      return Object.assign({}, state, { serverClientTimeOffset: action.payload })
    default:
      return state;
  }
}
 
export default combineReducers({notifications, domains, appState, leaderboards, badgelist});



// WEBPACK FOOTER //
// ./src/app/res/reducer.js